var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgByConnections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6225 2.52991H3.79203C2.86147 2.52991 1 3.10288 1 5.51348C1 7.92447 2.86147 8.53163 3.79203 8.53163H11.9177C12.8479 8.53163 14.6496 9.12075 14.6496 11.5317C14.6496 13.9423 12.8482 14.5442 11.9177 14.5442H1.70466",
    stroke: "#979BA8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6167 1L13.9742 2.52804L12.6167 4.00837M2.3805 13.0376L1.02271 14.5653L2.3805 16.046V13.0376Z",
    stroke: "#979BA8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByConnections);
export default __webpack_public_path__ + "static/media/by-connections.347304c6d8f3d9e4740357d43e1b4209.svg";
export { ForwardRef as ReactComponent };